import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

// Intercept fetch globally to handle expired/invalid tokens.
// If the backend returns 401, clear auth and redirect to login.
const _origFetch = window.fetch.bind(window);
window.fetch = async (...args) => {
  try {
    const res = await _origFetch(...args);
    if (res && res.status === 401) {
      // token expired or unauthorized - clear stored auth and redirect to login
      try {
        localStorage.removeItem('token');
        localStorage.removeItem('isAdmin');
      } catch (e) {
        // ignore storage errors
      }
      // hard redirect to login page
      window.location.href = '/';
      // return original response in case callers still inspect it
    }
    return res;
  } catch (err) {
    // network error - rethrow
    throw err;
  }
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
